import React from 'react';
import './Footer.css';
import { apiFetch } from '../lib/api';

const Footer: React.FC = () => {
  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.querySelector('input') as HTMLInputElement;
    const button = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    
    if (input && button) {
      const email = input.value;
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Subscribing...';
      
      try {
        await apiFetch('/api/newsletter/subscribe', {
          method: 'POST',
          json: { email }
        });
        
        button.textContent = '✓ Subscribed!';
        button.style.background = '#10b981';
        input.value = '';
        
        setTimeout(() => {
          button.textContent = originalText;
          button.style.background = '';
          button.disabled = false;
        }, 3000);
      } catch (error) {
        button.textContent = '✗ Failed';
        button.style.background = '#ef4444';
        
        setTimeout(() => {
          button.textContent = originalText;
          button.style.background = '';
          button.disabled = false;
        }, 3000);
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-social" aria-label="Social links">
            <a href="https://www.facebook.com/xyvn" target="_blank" rel="noopener noreferrer" className="footer-icon" aria-label="Facebook">
              f
            </a>
            <a href="https://x.com/xyvn" target="_blank" rel="noopener noreferrer" className="footer-icon" aria-label="X">
              X
            </a>
            <a href="https://www.instagram.com/xyvn/" target="_blank" rel="noopener noreferrer" className="footer-icon" aria-label="Instagram">
              ☐
            </a>
            <a href="https://www.youtube.com/@ARVIX" target="_blank" rel="noopener noreferrer" className="footer-icon" aria-label="YouTube">
              ▶
            </a>
          </div>

          <div className="footer-nav">
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
            <a href="/policies">Policies</a>
            <a href="/stores">Physical Stores</a>
            <a href="/manual">Online Manual</a>
          </div>

          <div className="footer-newsletter">
            <h3>Stay in the loop with our newsletter</h3>
            <form className="newsletter" onSubmit={handleNewsletterSubmit}>
              <input type="email" placeholder="Enter your email" required />
              <button type="submit" aria-label="Subscribe">
                →
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <div className="footer-copyright">© 2026 ARVIX. Powered by Shopify</div>
            <div className="legal-links">
              <a href="/policies/privacy-policy">Privacy policy</a>
              <a href="/policies/terms-of-service">Terms of service</a>
              <a href="/policies/refund-policy">Refund policy</a>
            </div>
          </div>

          <div className="footer-bottom-center" aria-label="Locale">
            <button type="button" className="locale-pill">English</button>
            <button type="button" className="locale-pill">Singapore (TWD $)</button>
          </div>

          <div className="footer-bottom-right" aria-label="Payment methods">
            <span className="pay-pill">AMEX</span>
            <span className="pay-pill">Apple Pay</span>
            <span className="pay-pill">Mastercard</span>
            <span className="pay-pill">VISA</span>
            <span className="pay-pill">PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
